<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="margin-top: 150px; text-align: center;"><em>The power of being known is an awareness of self,</em></p>
<p style="text-align: center;"><em>and an understanding of who you are and why you’re here.</em></p>
<p style="text-align: center;"><em>The power exists in the space of stillness.</em></p>
<p style="text-align: center;"><em>Be still, feel, ask, listen, breathe, receive, and know.</em></p>
<p style="text-align: center;"><em>Connect to the beat of your heart.</em></p>
<p style="text-align: center;"><em>Feel the present moment with the essence of your presence, and accept life as is wholeheartedly.</em></p>
<p style="text-align: center;"><em>Receive your self in this now moment.</em></p>
<p style="text-align: center;"><em>Receive love from deep within for love is the power of being known and love is a power worth knowing.</em></p>
<p style="text-align: center;"><em>Be still, feel, ask, listen, breathe, receive,</em></p>
<p style="text-align: center;"><em>and know.</em></p>
<p style="text-align: right;"><em>Dr. Sofia Costa</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1aa2acb2